import { RestAuthUser, SpotifyAccessToken } from '@/types'
import { sleep } from '@/utils/sleep'
import host from '../../utils/host'

class AuthRestMock {
  private host: string = host

  public loginUrl (campaignId: number): string {
    return `${this.host}/api/auth/spotify/user_token?redirect_uri=${encodeURIComponent(window.location.href)}&campaign_id=${campaignId}`
  }

  public async get (token: string): Promise<RestAuthUser> {
    await sleep(1200)

    return new Promise((resolve) => resolve({
      display_name: 'Wessel Vdp',
      email: 'wesselvanderpal@gmail.com',
      profile_image: 'https://scontent-cdg2-1.xx.fbcdn.net/v/t1.30497-1/c94.0.320.320a/p320x320/84628273_176159830277856_972693363922829312_n.jpg?_nc_cat=1&ccb=1-5&_nc_sid=0c64ff&_nc_ohc=8qwPGH98kkgAX_oJeur&_nc_ht=scontent-cdg2-1.xx&edm=AP4hL3IEAAAA&oh=00_AT-ZMXhRIDf26o8EUYRDXScN7ze0JWOWXU1_uoVS2AHdhw&oe=6200EB8A',
      registered_at: '2022-01-07T15:01:54.133598+00:00',
      streaming_service: 'spotify',
      streaming_service_country: 'DE',
      streaming_service_id: 'wesselnul',
      spotify_access_token: 'mock-user-access-token',
      spotify_access_token_expires_at: new Date(Date.now() + 3600 * 1000).toISOString(),
    }))
  }

  public async getSpotifyToken (token: string): Promise<SpotifyAccessToken> {
    await sleep(300)

    return new Promise((resolve) => resolve({
      access_token: 'mock-user-access-token',
      expires_at: new Date(Date.now() + 3600 * 1000).toISOString(),
    }))
  }
}

export default new AuthRestMock()
